// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea7aa7f8","239":"7a7bc843","732":"55c6f868"}[chunkId] + ".chunk.js";
};